import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';

interface Props {
	isUploadActive: boolean;
	hasDocuments: boolean;
	setUploadActive: () => void;
	setUploadInActive: () => void;
}

export const HeaderAction = ({
	hasDocuments,
	isUploadActive,
	setUploadActive,
	setUploadInActive,
}: Props) => {
	const tCapManage = useTranslationCapManage();

	if (isUploadActive && hasDocuments) {
		return (
			<Button
				leftSection={<Icon variant="reload" size="lg" />}
				variant="subtle"
				onClick={setUploadInActive}
			>
				{tCapManage('documents.buttons.go-back')}
			</Button>
		);
	}

	return (
		<Button
			onClick={setUploadActive}
			key="addTransaction"
			leftSection={<Icon variant="add" size="lg" />}
		>
			{tCapManage('documents.header_actions.add_new')}
		</Button>
	);
};
